import React, { useContext, useEffect, useState } from "react";
import GlobalContext from "../connections/GlobalContext";
import { Table, Modal, Button, Label, TextInput } from "flowbite-react";
import Swal from "sweetalert2";
import axios from "axios";
import { FaArrowLeft } from "react-icons/fa";
import engineGif from "../image/engine.gif";
import Select from "react-select";


const SpareLogDetails = ({ estimate_id, setShowTable }) => {
  const { globalValue } = useContext(GlobalContext);
  const [spareRecords, setSpareRecords] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedSpare, setSelectedSpare] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [tempService, setTempService] = useState("");
  const [enteredQuantity, setEnteredQuantity] = useState(0);
  const [quantityWarning, setQuantityWarning] = useState(false);
  const [temp_brand, setTemp_brand] = useState("");
  const [temp_model, setTemp_model] = useState("");

  const [staff_id, setStaff_id] = useState("");
  const [staffs_, setStaffs_] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchStaffs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/staffs`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      console.log(response.data);

      const staffOptions = response.data
        .filter((staff) => staff[6][0] !== "superadmin")
        .map((staff) => ({
          value: staff[2],
          label: staff[2],
        }));

      setStaffs_(staffOptions);
    } catch (error) {
      console.error("Error fetching staff data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords();
    fetchStaffs();
  }, []);

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/spare_record`,
        { estimate_id },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      setSpareRecords(response.data);
      console.log(response.data);
      return response.data;
    } catch (error) {
      Swal.fire({
        icon: "warning",
        title: "Failed to fetch data",
        text: "Please try again later.",
      });
      return [];
    } finally {
      setLoading(false);
    }
  };

  const spareFixedQuantity = () =>
    selectedSpare ? selectedSpare["Available Quantity"] : 0;

  const handleTakeButtonClick = (spare, record, brand, model1) => {
    console.log(brand, model1);
    setSelectedSpare(spare);
    setSelectedRecord(record);
    setEnteredQuantity(0);
    setQuantityWarning(false);
    setModalOpen(true);
    setTemp_brand(brand);
    setTemp_model(model1);
  };

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setEnteredQuantity(isNaN(value) ? 0 : value);
    setQuantityWarning(value > spareFixedQuantity());
  };

  const handleSpareTaken = async (spare_id, quantity, est_id, service_id) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/spare_taken`,
        {
          spare_id,
          quantity,
          est_id,
          service_id,
          staff_id: sessionStorage.getItem("name"),
          temp_brand,
          temp_model,
          mechanic: staff_id,
        },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );

      if (response.data === "success") {
        Swal.fire({ icon: "success", title: "Spare Taken Successfully" });
        fetchRecords();
      } else {
        Swal.fire({ icon: "warning", title: response.data.message });
      }
    } catch (error) {
      Swal.fire({ icon: "warning", title: "Spare not Taken" });
    } finally {
      setLoading(false);
    }
    setModalOpen(false);
  };

  return (
    <div>
      <div className="overflow-auto">
        <button
          onClick={() => setShowTable(false)}
          className="flex items-center bg-gray-500 p-2 rounded-md shadow-md text-gray-100 hover:bg-gray-600 me-4"
        >
          <FaArrowLeft className="w-5 h-5 mr-2" />
        </button>
        {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
            <img src={engineGif} alt="Loading..." className="w-24 h-24" />
          </div>
        )}
        {spareRecords.length > 0 ? (
          spareRecords.map((record) => (
            <div key={record.log_id} className="mb-4">
              {record.services.map((service) => (
                <>
                  <p>
                    {
                      spareRecords?.service_details?.find(
                        (s) => s.service_id === service
                      )?.service_name || "Unknown Service"
                    }
                  </p>

                  <table className="w-full border border-gray-300 shadow-md rounded-lg overflow-hidden">
                    <thead className="bg-gray-200 text-gray-900 text-sm font-semibold uppercase">
                      <tr>
                        {/* <th className="p-4 text-left border-b border-gray-300">Spare ID</th> */}
                        <th className="p-4 text-left border-b border-gray-300">
                          Spare Name
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Brand
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Model
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Quantity Used
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Actual Quantity
                        </th>
                        <th className="p-4 text-left text-red-500 border-b border-gray-300">
                          Available Quantit
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Price
                        </th>
                        <th className="p-4 text-left border-b border-gray-300">
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-300">
                      {record.spares.map(
                        (spare, index) =>
                          service === spare["Service ID"] && (
                            <tr
                              key={index}
                              className="hover:bg-gray-100 transition duration-200"
                            >
                              <td className="p-4 border-r border-gray-300">
                                {spare["Spare ID"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["Spare Name"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["brand"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["model1"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["Quantity Used"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["Actual Quantity"]}
                              </td>
                              <td className="p-4 text-red-500 font-bold border-r border-gray-300">
                                {spare["Available Quantity"]}
                              </td>
                              <td className="p-4 border-r border-gray-300">
                                {spare["Price"]}
                              </td>
                              <td className="p-4">
                                <button
                                  className="px-4 py-2 bg-blue-600 text-white font-medium rounded-lg shadow-md hover:bg-blue-700 transition duration-200"
                                  onClick={async () => {
                                    const updatedRecords = await fetchRecords();
                                    const updatedRecord = updatedRecords.find(
                                      (r) => r.log_id === record.log_id
                                    );
                                    const updatedSpare = updatedRecord?.spares.find(
                                      (s) => s["Spare ID"] === spare["Spare ID"]
                                    );
                                    setTempService(spare["Service ID"]);
                                    setTimeout(
                                      () =>
                                        handleTakeButtonClick(
                                          updatedSpare,
                                          updatedRecord,
                                          spare["brand"],
                                          spare["model1"]
                                        ),
                                      500
                                    );
                                  }}
                                >
                                  Take
                                </button>
                              </td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </table>
                </>
              ))}
            </div>
          ))
        ) : (
          <p>Loading records...</p>
        )}
      </div>

      {modalOpen && selectedSpare && selectedRecord && (
        <Modal show={modalOpen} onClose={() => setModalOpen(false)}>
          <Modal.Header className="flowbite-modal-h">Take Spare</Modal.Header>
          <Modal.Body className="flowbite-modal-h">
            <div className="space-y-4">
              <p>
                Spare Name: <b>{selectedSpare["Spare Name"]}</b>
              </p>
              <p>
                Fixed Quantity: <b>{spareFixedQuantity()}</b>
              </p>
              <div>
                <Label htmlFor="quantity">Enter Quantity:</Label>
                <TextInput
                  id="quantity"
                  type="number"
                  value={enteredQuantity}
                  onChange={handleQuantityChange}
                  min={0}
                  max={spareFixedQuantity()}
                  color="white"
                />
                {quantityWarning && (
                  <p className="text-red-500 text-sm mt-1">
                    Entered quantity exceeds the fixed quantity.
                  </p>
                )}
              </div>


              <Select
                options={staffs_}
                value={staffs_.find((staff) => staff.value === staff_id) || null}
                onChange={(selected) =>
                  setStaff_id(selected ? selected.value : "")
                }
                placeholder="Select Staff"
                isSearchable
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />


            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-h">
            <Button
              disabled={
                enteredQuantity > spareFixedQuantity() || enteredQuantity <= 0
              }
              onClick={() =>
                handleSpareTaken(
                  selectedSpare["Spare ID"],
                  enteredQuantity,
                  selectedRecord.estimate_id,
                  tempService
                )
              }
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default SpareLogDetails;
